export default "__VITE_ASSET__04PAK20k__"